<template>
  <el-dialog :title="select ? '查看考评配置' : isupload ? '编辑考评配置' :'新增考评配置'" :visible.sync="visible_v"
             width="800px"
             @close="
      () => {
        $emit('cancel')
      }
    ">
    <Form ref="addEvaluation" :label-width="120" :model="formCustom">
      <Form-item label="考评类目：" prop="evaluationCategory">
        <Input
          v-model="formCustom.evaluationCategory"
          :disabled="select"
          :maxlength="50"
          clearable
          style="width: 200px"
        ></Input>
      </Form-item>
      <Form-item label="考评表：" prop="evaluationItem">
        <el-checkbox-group v-model="formCustom.evaluationItem" :disabled="select || isupload">
          <el-checkbox label="员工考评表"></el-checkbox>
          <el-checkbox label="员工互评表"></el-checkbox>
          <el-checkbox label="用人部门打分表"></el-checkbox>
          <el-checkbox label="各部门打分表"></el-checkbox>
        </el-checkbox-group>
      </Form-item>
      <Form-item label="考评员：" prop="evaluationRole">
        <el-checkbox-group v-model="formCustom.evaluationRole" :disabled="select || isupload">
          <el-checkbox label="考勤员"></el-checkbox>
          <el-checkbox label="车管员"></el-checkbox>
          <el-checkbox label="站长"></el-checkbox>
        </el-checkbox-group>
      </Form-item>
      <Form-item label="考评范围：" prop="organizationIdList">
        <Cascader v-if="!isupload"
                  v-model="formCustom.organizationIdList" :data="organizationList"
                  change-on-select not-found-text='暂无数据，请创建'
                  @on-change='getOrganizationIdList'></Cascader>
        <Input
          v-if="isupload"
          :maxlength="50"
          :value="organization"
          clearable
          disabled
          style="width: 200px"
        ></Input>
      </Form-item>
      <Form-item label="受考评对象：" prop="evaluationEmployeeIds" style="width: 250px;">
        <el-select v-model="value" :disabled="select" placeholder="请选择">
          <el-option
            :value="1"
            label="全部">
          </el-option>
          <el-option
            :value="2"
            label="自定义">
          </el-option>
        </el-select>
        <el-select v-if="value == 2" v-model="formCustom.evaluationEmployeeIds" :disabled="select" filterable
                   multiple placeholder="请选择" style="width: 400px;">
          <el-option
            v-for="item in options"
            :key="item.employeeId"
            :label="item.employeeRealName"
            :value="item.employeeId">
          </el-option>
        </el-select>
      </Form-item>
      <Form-item>
        <Button v-if="!select" :loading="addloading" style="margin-left: 230px;" type="primary" @click="add">确定
        </Button>
      </Form-item>
    </Form>
  </el-dialog>
</template>
<script>
import permissionList from "@/libs/handlePermission.ts";
import {employeeList, organizationTreeAll} from '@/api/public'
import {companyEvaluationAdd, companyEvaluationPut} from '@/api/evaluation'

export default {
  props: {
    visible: {
      type: Boolean,
      required: false
    },
    model: {
      type: Object,
      default: () => null
    },
    isupload: {
      type: Boolean,
      required: false
    },
    select: {
      type: Boolean,
      required: false
    },
  },
  watch: {
    visible(v) {
      console.log(v)
      this.visible_v = v
      if (v) {
        this.init()
      }
    }
  },
  name: "company",
  data() {
    return {
      addloading: false,
      defaultValue: [],
      isShow: false,
      organization: '',
      formCustom: {
        evaluationItem: [],
        evaluationRole: [],
        organizationIdList: [],
        evaluationEmployeeIds: [],
        evaluationCategory: ''
      },
      visible_v: false,
      BaseUrl: process.env.VUE_APP_BASE_URL,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("getToken"),
      },
      value: 1,
      options: [],
      organizationList: [], // 组织机构列表
    }
  },
  components: {},
  mounted() {
    const list = JSON.parse(localStorage.getItem("routerList"))
    // eslint-disable-next-line new-cap
    this.btnList = new permissionList(list, this.$route.path).getList()
    let token = localStorage.getItem('getToken')
    let userString = decodeURIComponent((window.atob(token.split('.')[1].replace(/-/g, "+").replace(/_/g, "/"))))
    let user = JSON.parse(userString);
    this.init()
    this.roleType = user.roleType;
  },
  methods: {
    init() {
      organizationTreeAll().then((response) => {
        this.organizationList = response.data.data
        console.log(this.isupload)
        if (this.isupload) {
          console.log(this.model)
          this.formCustom.evaluationCategory = this.model.evaluationCategory
          this.formCustom.evaluationItem = this.model.evaluationItem.split(',')
          this.formCustom.evaluationRole = this.model.evaluationRole.split(',')
          let a = []
          a.push(this.model.groupId)
          if (this.model.companyId) {
            this.organization = this.model.groupName + '-' + this.model.companyName
            a.push(this.model.companyId)
          }
          if (this.model.deptId) {
            this.organization = this.model.groupName + '-' + this.model.companyName + '-' + this.model.deptName
            a.push(this.model.deptId)
          } else {
            this.organization = this.model.groupName
          }
          const pramas = {
            organizationId: a[a.length - 1]
          };
          this.formCustom.evaluationEmployeeIds = []
          if (this.model.evaluationEmployeeIds) {
            this.model.evaluationEmployeeIds.split(',').forEach(e => {
              this.formCustom.evaluationEmployeeIds.push(e * 1)
            })
          }
          employeeList(pramas).then(res => {
            this.options = res.data.data
            if (this.model.evaluationEmployeeIds && this.model.evaluationEmployeeIds.split(',').length == this.options.length) {
              this.value = 1
            } else {
              this.value = 2
            }
          })
        } else {
          this.formCustom = {
            evaluationItem: [],
            evaluationRole: [],
            organizationIdList: [],
            evaluationEmployeeIds: [],
            evaluationCategory: ''
          }
        }
      })
      this.isShow = false;
      // 定时器重新载入组件就可以触发组件拉取数据
      setTimeout(() => {
        this.isShow = true;
      }, 0);
    },
    getOrganizationIdList(val, data) {
      if (data.length !== 0) {
        console.log(this.formCustom.organizationIdList)
        this.formCustom.organizationIdList = data.map(item => item.id)
        console.log(this.formCustom.organizationIdList)
        const pramas = {
          organizationId: this.formCustom.organizationIdList[this.formCustom.organizationIdList.length - 1]
        };
        employeeList(pramas).then(res => {
          this.options = res.data.data
          this.formCustom.evaluationEmployeeIds = []
        })
      }
    },
    add() {
      this.addloading = true
      if (this.isupload) {
        let params = {}
        if (this.formCustom.evaluationCategory) {
          params.evaluationCategory = this.formCustom.evaluationCategory
        } else {
          this.$message.error("请先填写考评类目");
          this.addloading = false
          return
        }
        if (this.formCustom.evaluationItem.length) {
          params.evaluationItem = this.formCustom.evaluationItem.join(",")
        } else {
          this.$message.error("请先选择考评表");
          this.addloading = false
          return
        }
        if (this.formCustom.evaluationRole.length) {
          params.evaluationRole = this.formCustom.evaluationRole.join(",")
        } else {
          this.$message.error("请先选择考评员");
          this.addloading = false
          return
        }
        if (this.value == 1) {
          let list = []
          this.options.forEach(e => {
            list.push(e.employeeId)
          })
          params.evaluationEmployeeIds = list.join(",")
        } else if (this.formCustom.evaluationEmployeeIds.length) {
          let list = []
          this.formCustom.evaluationEmployeeIds.forEach(e => {
            list.push(e)
          })
          params.evaluationEmployeeIds = list.join(",")
        } else {
          this.$message.error("请先选择受考评对象");
          this.addloading = false
          return
        }
        params.companyEvaluationId = this.model.companyEvaluationId
        companyEvaluationPut(params).then(res => {
          this.addloading = false
          if (res.data.success) {
            this.$emit('successadd')
            this.$message.success(res.data.msg);
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(error => {
          this.addloading = false
          this.$message.error(error.response.data.msg);
        })
      } else {
        let pramas = {}
        if (this.formCustom.evaluationCategory) {
          pramas.evaluationCategory = this.formCustom.evaluationCategory
        } else {
          this.$message.error("请先填写考评类目");
          this.addloading = false
          return
        }
        if (this.formCustom.evaluationItem.length) {
          pramas.evaluationItem = this.formCustom.evaluationItem.join(",")
        } else {
          this.$message.error("请先选择考评表");
          this.addloading = false
          return
        }
        if (this.formCustom.evaluationRole.length) {
          pramas.evaluationRole = this.formCustom.evaluationRole.join(",")
        } else {
          this.$message.error("请先选择考评员");
          this.addloading = false
          return
        }
        if (this.formCustom.organizationIdList.length == 1) {
          pramas.organizationId = this.formCustom.organizationIdList[0]
        } else if (this.formCustom.organizationIdList.length == 2) {
          pramas.organizationId = this.formCustom.organizationIdList[1]
        } else if (this.formCustom.organizationIdList.length == 3) {
          pramas.organizationId = this.formCustom.organizationIdList[2]
        } else {
          this.$message.error("请先选择考评范围");
          this.addloading = false
          return
        }
        if (this.value == 1) {
          let list = []
          this.options.forEach(e => {
            list.push(e.employeeId)
          })
          pramas.evaluationEmployeeIds = list.join(",")
        } else if (this.formCustom.evaluationEmployeeIds.length) {
          let list = []
          this.formCustom.evaluationEmployeeIds.forEach(e => {
            list.push(e)
          })
          pramas.evaluationEmployeeIds = list.join(",")
        } else {
          this.$message.error("请先选择受考评对象");
          this.addloading = false
          return
        }
        companyEvaluationAdd(pramas).then(res => {
          this.addloading = false
          if (res.data.success) {
            this.$emit('successadd')
            this.$message.success(res.data.msg);
          } else {
            this.$message.error(res.data.msg);
          }
        })
      }
    }
  }
}
</script>
